import React from 'react';
import PropTypes from 'prop-types';
import SockJS from "sockjs-client";
import expect from "expect";
import * as Stompjs from "@stomp/stompjs";
class StompComponent extends React.Component {

    sockJSClient = undefined;
    client = undefined;

    componentDidMount() {
        const { url, userName } = this.props
        try {
            this.sockJSClient = new SockJS(url);
            this.client = Stompjs.Stomp.over(this.sockJSClient);
            let src = `/topic/topic-user-${userName}`
            // let src = `/app/subscribe/1`
            this.client.connect({},
                () => {
                    this.client.subscribe(src, this.tset);
                },
                (err) => {
                    console.info(`sockErr`, err);
                }
            )
        } catch (error) {

        }
    }

    tset = (res) => {
        const { onMessage } = this.props
        if (res && res.body && res.body.length > 0) {
            let retBody = JSON.parse(res.body);
            onMessage && onMessage(retBody);
        }
    }

    componentWillUnmount() {
        if (this.client) {
            this.client.disconnect();
        }
    }

    render() {
        return ``;
    }
}

StompComponent.propTypes = {
    url: PropTypes.string.isRequired,
    userName: PropTypes.string.isRequired,
    onMessage: PropTypes.func.isRequired,
};

export default StompComponent;